



















































































































































import {Vue, Component, Prop, Emit} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({})
export default class ObjektiCard2TabOsnovno extends mixins(ComponentBaseMixin) {
    @Prop() store!: {};
    @Prop() countries!: [];
    @Prop({default: false}) isBusySave!: boolean;

    async created() {
        this.$nextTick(() => {
            (<any>this.$refs.observerOsnovno).validate();
        });
    }

    @Emit() newStore() {
    }

    @Emit() deleteStore() {
    }

    @Emit() saveStore() {

    }

}
